import React, { Fragment, useState, useContext, useEffect } from "react";

import { Grid, Link, Box, Typography, Breadcrumbs } from "@material-ui/core";
import { alpha } from "@material-ui/core/styles/colorManipulator";
import { Alert, AlertTitle } from "@material-ui/lab";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";

import Spinner from "../../layout/Spinner";

import DisputeFilter from "./DisputeFilter";
import DisputeForm from "./DisputeForm";
import DisputeResult from "./DisputeResult";

import DisputeContext from "../../../context/paypal/disputes/DisputeContext";

const DisputeHome = () => {
  const disputeContext = useContext(DisputeContext);

  const [disputesItems, setDisputesItems] = useState([]);
  const [filterDataCounts, setFilterDataCounts] = useState(0);
  const [sendDisputeID, setSendDisputeID] = useState();
  const [messagesClaimsSelected, setMessagesClaimsSelected] = useState([1, 2]);
  const [caseSelected, setCaseSelected] = useState([1, 2]);
  const [reasonSelected, setReasonSelected] = useState([
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
  ]);
  const [sendStatusRequest, setSendStatusRequest] = useState([]);
  const [monthSelected, setMonthSelected] = useState([]);
  const [returnedMsg, setReturnedMsg] = useState();
  const [state, setState] = useState({
    f_value: "",
    min_value: "",
    max_value: "",
    day_value: "",
    year_value: "",
    message_value: "",
    email_value: "",
    errors: {
      f_value: "",
      min_value: "",
      max_value: "",
      day_value: "",
      year_value: "",
      message_value: "",
      email_value: "",
    },
    success_alert: "",
    got_order: false,
  });
  const { loading, disputes, getDisputes, getDisputeById, dispute } =
    disputeContext;
  const [renderTable, setRenderTable] = useState(false);

  // On load, get all data from database
  useEffect(() => {
    getDisputes();
    //eslint-disable-next-line
  }, []);

  // Re-render Dispute Result everytime a Paypal API call success
  useEffect(() => {
    if (state.success_alert) {
      getDisputeById(dispute.dispute_id);
      setRenderTable(true);
    }
    //eslint-disable-next-line
  }, [state.success_alert]);

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography> {children} </Typography>{" "}
          </Box>
        )}{" "}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };

  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: "center",
      color: theme.palette.text.secondary,
    },
    errorAlert: {
      width: "40%",
      "& > * + *": {
        marginTop: theme.spacing(5),
      },
      position: "absolute",
    },
    successAlert: {
      width: "20%",
      "& > * + *": {
        marginTop: theme.spacing(5),
      },
      position: "absolute",
    },
    errorAlertColor: {
      backgroundColor: alpha("#ffc2b3", 0.7),
    },
    successAlertColor: {
      backgroundColor: alpha("#e6ffcc", 0.7),
    },
  }));

  const classes = useStyles();

  const onBreadCrumbCLick = (e) => {
    e.preventDefault();
    if (loading === false) {
      setSendDisputeID();
    }
    if (renderTable) {
      getDisputes();
      setRenderTable(false);
    }
  };

  return (
    <div className={classes.root}>
      <Grid container direction="row" justifyContent="center">
        {" "}
        {state.errors.message_value ? (
          <div className={classes.errorAlert}>
            <Alert severity="error" className={classes.errorAlertColor}>
              {" "}
              <AlertTitle>
                <strong> Error </strong>{" "}
              </AlertTitle>{" "}
              {state.errors.message_value}{" "}
            </Alert>{" "}
          </div>
        ) : null}{" "}
        {state.success_alert ? (
          <div className={classes.successAlert}>
            <Alert severity="success" className={classes.successAlertColor}>
              {" "}
              <AlertTitle>
                <strong> Success </strong>{" "}
              </AlertTitle>{" "}
            </Alert>{" "}
          </div>
        ) : null}{" "}
      </Grid>{" "}
      <Grid container direction="column" spacing={1}>
        <Grid container justifyContent="flex-start">
          <Grid item xs={12}>
            <Typography variant="h4"> Dispute </Typography>{" "}
          </Grid>{" "}
          <Grid item xs={12}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link color="inherit" href="/" onClick={onBreadCrumbCLick}>
                Dispute{" "}
              </Link>{" "}
              {sendDisputeID ? (
                <Link color="inherit"> {sendDisputeID} </Link>
              ) : null}{" "}
            </Breadcrumbs>{" "}
          </Grid>{" "}
        </Grid>{" "}
        <Grid item xs={12}>
          {" "}
          {sendDisputeID ? (
            <Fragment>
              <DisputeResult
                sendDisputeID={sendDisputeID}
                state={state}
                setState={setState}
                returnedMsg={returnedMsg}
                setReturnedMsg={setReturnedMsg}
              />{" "}
            </Fragment>
          ) : (
            <Grid container direction="column" spacing={1}>
              <Grid item>
                {" "}
                {/* Dispute Filter get data from backend and filtering data */}{" "}
                <DisputeFilter
                  setDisputesItems={setDisputesItems}
                  setFilterDataCounts={setFilterDataCounts}
                  messagesClaimsSelected={messagesClaimsSelected}
                  setMessagesClaimsSelected={setMessagesClaimsSelected}
                  caseSelected={caseSelected}
                  setCaseSelected={setCaseSelected}
                  reasonSelected={reasonSelected}
                  setReasonSelected={setReasonSelected}
                  sendStatusRequest={sendStatusRequest}
                  setSendStatusRequest={setSendStatusRequest}
                  state={state}
                  setState={setState}
                  monthSelected={monthSelected}
                  setMonthSelected={setMonthSelected}
                />{" "}
              </Grid>{" "}
              <Grid item>
                {" "}
                {/* DisputeForm get data from Dispute Filter and set it into table form */}{" "}
                {disputes ? (
                  <DisputeForm
                    filterDataCounts={filterDataCounts}
                    disputesItems={disputesItems}
                    setSendDisputeID={setSendDisputeID}
                  />
                ) : (
                  <Grid
                    container
                    direction="row"
                    alignItems="flex-end"
                    justifyContent="center"
                    style={{
                      height: 250,
                    }}
                  >
                    <Grid item>
                      <Spinner />
                    </Grid>{" "}
                  </Grid>
                )}{" "}
              </Grid>{" "}
            </Grid>
          )}{" "}
        </Grid>{" "}
      </Grid>{" "}
    </div>
  );
};

export default DisputeHome;
